export default "__VITE_ASSET__d12b34ed__"